import project1 from '../assets/money.png';
import project2 from '../assets/interior.jpg';
import project3 from '../assets/blog.jpg';
import project4 from '../assets/astrology.jpg';
import project5 from '../assets/chat.jpg';
import project6 from '../assets/gunshop.jpg';

export const portfolio_data = [
    {
        id: '1',
        title: 'Money management app',
        githubUrl: [
            {
                frontend: 'https://github.com/vasanthmn1/capstone-project-client',
            },
            {
                backend: 'https://github.com/vasanthmn1/capstone-project-backend',
            },
        ],
        websiteUrl: 'https://admirable-pudding-b31006.netlify.app/',
        img: project1,
        optionTitle: "User",
        adminEmail: " 1@gmail.com",
        adminPassword: " 1@gmail.com"
    },
    {
        id: '2',
        title: 'Interior',
        githubUrl: [
            {
                frontend: 'https://github.com/vasanthmn1/interior-frontendapp',
            },
            {
                backend: 'https://github.com/vasanthmn1/interior-bakend',
            },
        ],
        websiteUrl: 'https://master--chic-pithivier-376c30.netlify.app/',
        img: project2,
        optionTitle: "Admin",
        adminEmail: "admin@gmail.com",
        adminPassword: " admin1234",
        optionPath: "...../admin",
        optionCode: "1122",

    },
    {
        id: '3',
        title: 'Blog',
        githubUrl: [
            {
                frontend: 'https://github.com/vasanthmn1/blog-frontend',
            },
            {
                backend: 'https://github.com/vasanthmn1/backend-blog',
            },
        ],
        websiteUrl: 'https://spontaneous-mooncake-060ef3.netlify.app/',
        img: project3,
        optionTitle: "User",
        adminEmail: " 1@gmail.com",
        adminPassword: " 1@gmail.com"
    },
    {
        id: '4',
        title: 'Astrology',
        githubUrl: [
            {
                frontend: 'https://github.com/vasanthmn1/frontend-astrology',
            },
            {
                backend: 'https://github.com/vasanthmn1/backend-astrology',
            },
        ],
        websiteUrl: 'https://celebrated-moonbeam-21c681.netlify.app/',
        img: project4,
        optionTitle: "Admin",
        adminEmail: "admin@gmail.com",
        adminPassword: " admin1234",
        optionTitle2: "User",
        userEmail: "1@gmail.com",
        userPassword: "1@gmail.com"
    },
    {
        id: '5',
        title: 'Mini Chat',
        githubUrl: [
            {
                frontend: 'https://github.com/vasanthmn1/minichat-frontend',
            },
            {
                backend: 'https://github.com/vasanthmn1/minichat-backend',
            },
        ],
        websiteUrl: 'https://clever-chaja-38768f.netlify.app/',
        img: project5,
        // optionTitle: "Admin",


        // adminEmail: "Eamil: admin@gmail.com",
        // adminPassword: "Password:  admin1234"
    },
    {
        id: '6',
        title: 'OnGuns',
        githubUrl: [
            {
                frontend: 'https://github.com/vasanthmn1/frontend-gunshop',
            },
            {
                backend: 'https://github.com/vasanthmn1/backend-gunshop-stripe',
            },
        ],
        websiteUrl: 'https://magical-melba-799351.netlify.app/',
        img: project6,
        adminEmail: "admin@gmail.com",
        adminPassword: " admin1234"

    },
];